import { PayloadAction, createSlice } from '@reduxjs/toolkit';

type ListingState = {
  ratedListing: {
    id: number;
  };
};

const initialState: ListingState = {
  ratedListing: {
    id: 0,
  },
};

const listingSlice = createSlice({
  name: 'listing',
  initialState,
  reducers: {
    setRatedListing: (
      state,
      action: PayloadAction<ListingState['ratedListing']>,
    ) => {
      return {
        ...state,
        ratedListing: action.payload,
      };
    },
  },
});

export const { setRatedListing } = listingSlice.actions;

export default listingSlice.reducer;
